import React, {useState} from 'react';
import './NhomLinhVuc.css';

function  NhomLinhVuc() {
        const [showPage, setShowPage] = useState(false)
         const [addNhomLinhVuc, setAddNhomLinhVuc] = useState("add-nhom-linh-vuc");
    
    
        // hàm mở page
        const openPageAdd = () => {
            setShowPage(true);
            setAddNhomLinhVuc("add-nhom-linh-vuc")
        }
    
        //hàm đóng page
        const cancelPageAdd = () => {
            setShowPage(false)
        }
    
        return (
            <div>
                 {/* NHÓM LĨNH VỰC */}
    <div className="nhom-linh-vuc-wrapper">

        <div className="nhom-linh-vuc-header">
            <h2 className="nhom-linh-vuc-title">
                Nhóm lĩnh vực
            </h2>

            <div className="nhom-linh-vuc-breadcrumb">
                <span className="nhom-linh-vuc-breadcrumb-item">Trang chủ</span>
                <span className="nhom-linh-vuc-breadcrumb-separator">/</span>

                <span className="nhom-linh-vuc-breadcrumb-item">
                    Quản lý lĩnh vực ngành
                </span>

                <span className="nhom-linh-vuc-breadcrumb-separator">/</span>

                <span className="nhom-linh-vuc-breadcrumb-active">
                    Nhóm lĩnh vực
                </span>
            </div>
        </div>

        <div className="nhom-linh-vuc-toolbar">

            <div className="nhom-linh-vuc-toolbar-left">

                <div className="nhom-linh-vuc-search-box">
                    <input
                        type="text"
                        className="nhom-linh-vuc-search-input"
                        placeholder="Tìm kiếm theo mã, tên nhóm..."
                    />
                    <i className="fa-solid fa-magnifying-glass nhom-linh-vuc-search-icon"></i>
                </div>

                <div className="nhom-linh-vuc-filter-box">

                    <label className="nhom-linh-vuc-filter-label">
                        Trạng thái
                    </label>

                    <select className="nhom-linh-vuc-filter-select">
                        <option>Tất cả</option>
                    </select>

                </div>

            </div>

            <div className="nhom-linh-vuc-toolbar-right">

                <button className="nhom-linh-vuc-btn-import">
                    <i className="fa-solid fa-download icon-nhom-linh-vuc"></i>
                    Nhập dữ liệu
                </button>

                <button className="nhom-linh-vuc-btn-export">
                    <i className="fa-solid fa-upload icon-nhom-linh-vuc"></i>
                    Xuất dữ liệu
                </button>

                <button className="nhom-linh-vuc-btn-add" onClick={openPageAdd}>
                    <i className="fa-solid fa-plus icon-nhom-linh-vuc"></i>
                    Thêm nhóm lĩnh vực
                </button>

            </div>

        </div>

        <div className="nhom-linh-vuc-table-wrapper">

            <table className="nhom-linh-vuc-table">

                <thead className="nhom-linh-vuc-table-head">

                    <tr className="nhom-linh-vuc-table-row-head">

                        <th className="nhom-linh-vuc-th-stt">
                            STT
                        </th>

                        <th className="nhom-linh-vuc-th-ma">
                            Mã nhóm
                            <span className="nhom-linh-vuc-sort-icon">
                                <i className="fa-solid fa-sort"></i>
                            </span>
                        </th>

                        <th className="nhom-linh-vuc-th-ten">
                            Tên nhóm lĩnh vực
                            <span className="nhom-linh-vuc-sort-icon">
                                <i className="fa-solid fa-sort"></i>
                            </span>
                        </th>

                        <th className="nhom-linh-vuc-th-mota">
                            Mô tả
                        </th>

                        <th className="nhom-linh-vuc-th-trangthai">
                            Trạng thái
                            <span className="nhom-linh-vuc-sort-icon">
                                <i className="fa-solid fa-sort"></i>
                            </span>
                        </th>

                        <th className="nhom-linh-vuc-th-thutu">
                            Thứ tự
                            <span className="nhom-linh-vuc-sort-icon">
                                <i className="fa-solid fa-sort"></i>
                            </span>
                        </th>

                        <th className="nhom-linh-vuc-th-ngaytao">
                            Ngày tạo
                            <span className="nhom-linh-vuc-sort-icon">
                                <i className="fa-solid fa-sort"></i>
                            </span>
                        </th>

                        <th className="nhom-linh-vuc-th-thaotac">
                            Thao tác
                        </th>

                    </tr>

                </thead>

                <tbody className="nhom-linh-vuc-table-body">

                    <tr className="nhom-linh-vuc-row">
                        <td className="nhom-linh-vuc-td-stt">1</td>
                        <td className="nhom-linh-vuc-td-ma">N001</td>
                        <td className="nhom-linh-vuc-td-ten">Sản xuất công nghiệp</td>
                        <td className="nhom-linh-vuc-td-mota">Các lĩnh vực liên quan đến sản xuất công nghiệp</td>
                        <td className="nhom-linh-vuc-td-trangthai">
                            <span className="nhom-linh-vuc-status-active">Hoạt động</span>
                        </td>
                        <td className="nhom-linh-vuc-td-thutu">1</td>
                        <td className="nhom-linh-vuc-td-ngaytao">15/05/2024 08:30</td>
                        <td className="nhom-linh-vuc-td-thaotac">
                            <button className="nhom-linh-vuc-btn-edit"><i className="fa-regular fa-pen-to-square"></i></button>
                            <button className="nhom-linh-vuc-btn-view"><i className="fa-regular fa-eye"></i></button>
                            <button className="nhom-linh-vuc-btn-delete"><i className="fa-regular fa-trash-can"></i></button>
                        </td>
                    </tr>

                    <tr className="nhom-linh-vuc-row">
                        <td className="nhom-linh-vuc-td-stt">2</td>
                        <td className="nhom-linh-vuc-td-ma">N002</td>
                        <td className="nhom-linh-vuc-td-ten">Thương mại - Dịch vụ</td>
                        <td className="nhom-linh-vuc-td-mota">Các lĩnh vực về thương mại và dịch vụ</td>
                        <td className="nhom-linh-vuc-td-trangthai">
                            <span className="nhom-linh-vuc-status-active">Hoạt động</span>
                        </td>
                        <td className="nhom-linh-vuc-td-thutu">2</td>
                        <td className="nhom-linh-vuc-td-ngaytao">15/05/2024 08:30</td>
                        <td className="nhom-linh-vuc-td-thaotac">
                            <button className="nhom-linh-vuc-btn-edit"><i className="fa-regular fa-pen-to-square"></i></button>
                            <button className="nhom-linh-vuc-btn-view"><i className="fa-regular fa-eye"></i></button>
                            <button className="nhom-linh-vuc-btn-delete"><i className="fa-regular fa-trash-can"></i></button>
                        </td>
                    </tr>

                    <tr className="nhom-linh-vuc-row">
                        <td className="nhom-linh-vuc-td-stt">3</td>
                        <td className="nhom-linh-vuc-td-ma">N003</td>
                        <td className="nhom-linh-vuc-td-ten">Điện lực - Năng lượng</td>
                        <td className="nhom-linh-vuc-td-mota">Các lĩnh vực về điện lực và năng lượng</td>
                        <td className="nhom-linh-vuc-td-trangthai">
                            <span className="nhom-linh-vuc-status-active">Hoạt động</span>
                        </td>
                        <td className="nhom-linh-vuc-td-thutu">3</td>
                        <td className="nhom-linh-vuc-td-ngaytao">15/05/2024 08:30</td>
                        <td className="nhom-linh-vuc-td-thaotac">
                            <button className="nhom-linh-vuc-btn-edit"><i className="fa-regular fa-pen-to-square"></i></button>
                            <button className="nhom-linh-vuc-btn-view"><i className="fa-regular fa-eye"></i></button>
                            <button className="nhom-linh-vuc-btn-delete"><i className="fa-regular fa-trash-can"></i></button>
                        </td>
                    </tr>

                    <tr className="nhom-linh-vuc-row">
                        <td className="nhom-linh-vuc-td-stt">4</td>
                        <td className="nhom-linh-vuc-td-ma">N004</td>
                        <td className="nhom-linh-vuc-td-ten">Xuất nhập khẩu</td>
                        <td className="nhom-linh-vuc-td-mota">Các lĩnh vực về xuất nhập khẩu hàng hóa</td>
                        <td className="nhom-linh-vuc-td-trangthai"><span className="nhom-linh-vuc-status-active">Hoạt động</span></td>
                        <td className="nhom-linh-vuc-td-thutu">4</td>
                        <td className="nhom-linh-vuc-td-ngaytao">15/05/2024 08:30</td>
                        <td className="nhom-linh-vuc-td-thaotac">
                            <button className="nhom-linh-vuc-btn-edit"><i className="fa-regular fa-pen-to-square"></i></button>
                            <button className="nhom-linh-vuc-btn-view"><i className="fa-regular fa-eye"></i></button>
                            <button className="nhom-linh-vuc-btn-delete"><i className="fa-regular fa-trash-can"></i></button>
                        </td>
                    </tr>

                    <tr className="nhom-linh-vuc-row">
                        <td className="nhom-linh-vuc-td-stt">5</td>
                        <td className="nhom-linh-vuc-td-ma">N005</td>
                        <td className="nhom-linh-vuc-td-ten">Thị trường trong nước</td>
                        <td className="nhom-linh-vuc-td-mota">Các lĩnh vực quản lý thị trường trong nước</td>
                        <td className="nhom-linh-vuc-td-trangthai"><span className="nhom-linh-vuc-status-active">Hoạt động</span></td>
                        <td className="nhom-linh-vuc-td-thutu">5</td>
                        <td className="nhom-linh-vuc-td-ngaytao">15/05/2024 08:30</td>
                        <td className="nhom-linh-vuc-td-thaotac">
                            <button className="nhom-linh-vuc-btn-edit"><i className="fa-regular fa-pen-to-square"></i></button>
                            <button className="nhom-linh-vuc-btn-view"><i className="fa-regular fa-eye"></i></button>
                            <button className="nhom-linh-vuc-btn-delete"><i className="fa-regular fa-trash-can"></i></button>
                        </td>
                    </tr>

                    <tr className="nhom-linh-vuc-row">
                        <td className="nhom-linh-vuc-td-stt">6</td>
                        <td className="nhom-linh-vuc-td-ma">N006</td>
                        <td className="nhom-linh-vuc-td-ten">Khuyến công - Xúc tiến thương mại</td>
                        <td className="nhom-linh-vuc-td-mota">Khuyến công và xúc tiến thương mại</td>
                        <td className="nhom-linh-vuc-td-trangthai"><span className="nhom-linh-vuc-status-active">Hoạt động</span></td>
                        <td className="nhom-linh-vuc-td-thutu">6</td>
                        <td className="nhom-linh-vuc-td-ngaytao">15/05/2024 08:30</td>
                        <td className="nhom-linh-vuc-td-thaotac">
                            <button className="nhom-linh-vuc-btn-edit"><i className="fa-regular fa-pen-to-square"></i></button>
                            <button className="nhom-linh-vuc-btn-view"><i className="fa-regular fa-eye"></i></button>
                            <button className="nhom-linh-vuc-btn-delete"><i className="fa-regular fa-trash-can"></i></button>
                        </td>
                    </tr>

                    <tr className="nhom-linh-vuc-row">
                        <td className="nhom-linh-vuc-td-stt">7</td>
                        <td className="nhom-linh-vuc-td-ma">N007</td>
                        <td className="nhom-linh-vuc-td-ten">An toàn thực phẩm</td>
                        <td className="nhom-linh-vuc-td-mota">Các lĩnh vực về an toàn thực phẩm</td>
                        <td className="nhom-linh-vuc-td-trangthai">
                            <span className="nhom-linh-vuc-status-pause">Tạm dừng</span>
                        </td>
                        <td className="nhom-linh-vuc-td-thutu">7</td>
                        <td className="nhom-linh-vuc-td-ngaytao">15/05/2024 08:30</td>
                        <td className="nhom-linh-vuc-td-thaotac">
                            <button className="nhom-linh-vuc-btn-edit"><i className="fa-regular fa-pen-to-square"></i></button>
                            <button className="nhom-linh-vuc-btn-view"><i className="fa-regular fa-eye"></i></button>
                            <button className="nhom-linh-vuc-btn-delete"><i className="fa-regular fa-trash-can"></i></button>
                        </td>
                    </tr>

                    <tr className="nhom-linh-vuc-row">
                        <td className="nhom-linh-vuc-td-stt">8</td>
                        <td className="nhom-linh-vuc-td-ma">N008</td>
                        <td className="nhom-linh-vuc-td-ten">Tiết kiệm năng lượng</td>
                        <td className="nhom-linh-vuc-td-mota">Các lĩnh vực về tiết kiệm năng lượng</td>
                        <td className="nhom-linh-vuc-td-trangthai"><span className="nhom-linh-vuc-status-active">Hoạt động</span></td>
                        <td className="nhom-linh-vuc-td-thutu">8</td>
                        <td className="nhom-linh-vuc-td-ngaytao">15/05/2024 08:30</td>
                        <td className="nhom-linh-vuc-td-thaotac">
                            <button className="nhom-linh-vuc-btn-edit"><i className="fa-regular fa-pen-to-square"></i></button>
                            <button className="nhom-linh-vuc-btn-view"><i className="fa-regular fa-eye"></i></button>
                            <button className="nhom-linh-vuc-btn-delete"><i className="fa-regular fa-trash-can"></i></button>
                        </td>
                    </tr>

                </tbody>

            </table>

        </div>

        <div className="nhom-linh-vuc-footer">

            <div className="nhom-linh-vuc-record-info">
                Hiển thị 1 đến 8 trong tổng số 8 bản ghi
            </div>

            <div className="nhom-linh-vuc-pagination">

                <select className="nhom-linh-vuc-page-size">
                    <option>10</option>
                </select>

                <button className="nhom-linh-vuc-page-prev">
                    <i className="fa-solid fa-chevron-left"></i>
                </button>

                <button className="nhom-linh-vuc-page-current">
                    1
                </button>

                <button className="nhom-linh-vuc-page-next">
                    <i className="fa-solid fa-chevron-right"></i>
                </button>

            </div>

        </div>

    </div>








            {
                showPage && (
                    <div
                     className={
                    addNhomLinhVuc === "add-nhom-linh-vuc"
                        ? "group-danh-muc-linh-vuc-open-page-add-show"
                        : "group-danh-muc-linh-vuc-open-page-add-hide"
                }
                    
                    >


                          <div className="col-sm-10">
            <div className="add-group-linh-vuc-container">

                {/* Header */}
                <div className="add-group-linh-vuc-header">
                    <h2 className="add-group-linh-vuc-title">
                        Thêm nhóm lĩnh vực
                    </h2>

                    <div className="add-group-linh-vuc-breadcrumb">
                        Trang chủ
                        <span className="add-group-linh-vuc-breadcrumb-separator">/</span>
                        Quản lý lĩnh vực ngành
                        <span className="add-group-linh-vuc-breadcrumb-separator">/</span>
                        Nhóm lĩnh vực
                        <span className="add-group-linh-vuc-breadcrumb-separator">/</span>
                        Thêm nhóm lĩnh vực
                    </div>
                </div>

                {/* Form Wrapper */}
                <div className="add-group-linh-vuc-form-wrapper">

                    <div className="add-group-linh-vuc-grid">

                        {/* Left */}
                        <div className="add-group-linh-vuc-left">

                            <h4 className="add-group-linh-vuc-section-title">
                                Thông tin nhóm lĩnh vực
                            </h4>

                            <div className="add-group-linh-vuc-form-row">
                                <label className="add-group-linh-vuc-label">
                                    Mã nhóm <span>*</span>
                                </label>

                                <div className="add-group-linh-vuc-input-wrap">
                                    <input
                                        type="text"
                                        className="add-group-linh-vuc-input-ma"
                                        placeholder="Nhập mã nhóm lĩnh vực"
                                    />

                                    <div className="add-group-linh-vuc-helper">
                                        Mã viết tắt, không trùng với mã nhóm khác (VD: N001)
                                    </div>
                                </div>
                            </div>

                            <div className="add-group-linh-vuc-form-row">
                                <label className="add-group-linh-vuc-label">
                                    Tên nhóm lĩnh vực <span>*</span>
                                </label>

                                <input
                                    type="text"
                                    className="add-group-linh-vuc-input-ten-group"
                                    placeholder="Nhập tên nhóm lĩnh vực"
                                />
                            </div>

                            <div className="add-group-linh-vuc-form-row">
                                <label className="add-group-linh-vuc-label">
                                    Mô tả <span>*</span>
                                </label>

                                <div className="add-group-linh-vuc-textarea-wrap">
                                    <textarea
                                        className="add-group-linh-vuc-textarea-mo-ta"
                                        placeholder="Nhập mô tả nhóm lĩnh vực"
                                    ></textarea>

                                    <span className="add-group-linh-vuc-counter">
                                        0/255
                                    </span>
                                </div>
                            </div>

                            <div className="add-group-linh-vuc-form-row">
                                <label className="add-group-linh-vuc-label">
                                    Thứ tự hiển thị <span>*</span>
                                </label>

                                <div className="add-group-linh-vuc-input-wrap">
                                    <input
                                        type="number"
                                        defaultValue="0"
                                        className="add-group-linh-vuc-input-thu-tu"
                                    />

                                    <div className="add-group-linh-vuc-helper">
                                        Số thứ tự càng nhỏ hiển thị càng lên đầu
                                    </div>
                                </div>
                            </div>

                            <div className="add-group-linh-vuc-form-row">
                                <label className="add-group-linh-vuc-label">
                                    Trạng thái <span>*</span>
                                </label>

                                <div className="add-group-linh-vuc-radio-group">

                                    <label className="add-group-linh-vuc-radio-item">
                                        <input
                                            type="radio"
                                            name="status"
                                            defaultChecked
                                        />
                                        Hoạt động
                                    </label>

                                    <label className="add-group-linh-vuc-radio-item">
                                        <input
                                            type="radio"
                                            name="status"
                                        />
                                        Tạm dừng
                                    </label>

                                </div>
                            </div>

                        </div>

                        {/* Right */}
                        <div className="add-group-linh-vuc-right">

                            <h4 className="add-group-linh-vuc-section-title">
                                Thông tin bổ sung
                            </h4>

                            <div className="add-group-linh-vuc-form-row-right">
                                <label className="add-group-linh-vuc-label-right">
                                    Lĩnh vực ngành cha
                                </label>

                                <div className="add-group-linh-vuc-select-wrap">
                                    <select className="add-group-linh-vuc-select">
                                        <option>-- Không chọn --</option>
                                    </select>

                                    <div className="add-group-linh-vuc-helper">
                                        Chọn lĩnh vực ngành cha nếu nhóm này thuộc một lĩnh vực ngành cụ thể
                                    </div>
                                </div>
                            </div>

                            <div className="add-group-linh-vuc-form-row-right">
                                <label className="add-group-linh-vuc-label-right">
                                    Ghi chú
                                </label>

                                <div className="add-group-linh-vuc-textarea-wrap-right">
                                    <textarea
                                        className="add-group-linh-vuc-textarea-note"
                                        placeholder="Nhập ghi chú (nếu có)"
                                    ></textarea>

                                    <span className="add-group-linh-vuc-counter-right">
                                        0/255
                                    </span>
                                </div>
                            </div>

                            <div className="add-group-linh-vuc-guide-box">

                                <div className="add-group-linh-vuc-guide-title">
                                    <i className="fa-solid fa-circle-info"></i>
                                    Hướng dẫn
                                </div>

                                <ul className="add-group-linh-vuc-guide-list">
                                    <li>Mã nhóm là duy nhất và không thể thay đổi sau khi tạo.</li>
                                    <li>Vui lòng chọn lĩnh vực ngành cha (nếu có) để phân loại theo cấu trúc.</li>
                                    <li>Trạng thái "Tạm dừng" sẽ ẩn nhóm lĩnh vực khỏi danh sách sử dụng.</li>
                                </ul>

                            </div>

                        </div>

                    </div>

                    {/* Footer */}
                    <div className="add-group-linh-vuc-footer">

                        <button className="add-group-linh-vuc-btn-back" onClick={cancelPageAdd}>
                            <i className="fa-solid fa-arrow-left"></i>
                            Quay lại danh sách
                        </button>

                        <div className="add-group-linh-vuc-footer-right">

                            <button className="add-group-linh-vuc-btn-cancel" onClick={cancelPageAdd}>
                                Hủy bỏ
                            </button>

                            <button className="add-group-linh-vuc-btn-add">
                                <i className="fa-regular fa-floppy-disk"></i>
                                Lưu và thêm mới
                            </button>

                            <button className="add-group-linh-vuc-btn-save">
                                <i className="fa-regular fa-floppy-disk"></i>
                                Lưu
                            </button>

                        </div>

                    </div>

                </div>

            </div>
        </div>

                    </div>
                )
            }






            </div>
        );
    }


export default NhomLinhVuc;